import { yupResolver } from '@hookform/resolvers/yup';
import { Box, Grid2, Paper, Typography, useTheme, IconButton, Collapse } from '@mui/material';
import { ExpandMore, ExpandLess } from '@mui/icons-material';
import React, { FC, useRef, useState } from 'react';
import { SubmitHandler, useForm } from 'react-hook-form';
import { useNavigate } from 'react-router-dom';
import * as Yup from 'yup';
import { Button } from '../../../Components/Form/Button/button.scomponent';
import { Input } from '../../../Components/Form/Input/input.component';
import { Switch } from '../../../Components/Form/Switch/switch.component';
import { Loader } from '../../../Components/Loader';
import { BaseContentPage } from '../../../Components/Templates/BaseContentPage/base-content-page.componen';
import { BaseScreen } from '../../../Components/Templates/BaseScreen/basescreen.component';
import { useToast } from '../../../Hooks/ToasContext';
import { CreateProductUseCase } from '../../../Usecase/Products/create-product-usecase';
import { CreateCollaboratorsUseCase } from '../../../Usecase/Collaborators/create-collaborators-usecase';
import { useCreateCollaborators } from './create-collaborators.hook';
import { ShowCollaboratorsUseCase } from '../../../Usecase/Collaborators/show-collaborators-usecase';
import { UpdateCollaboratorsUseCase } from '../../../Usecase/Collaborators/update-collaborators-usecase';
import { Can } from '../../../Components/Can';



interface ProductProps {
    name: string;
    code: string;
    ncm: string;
    personalized: boolean
    createOnNuvemShop: boolean;
    createOnOmie: boolean;
    createOnb2b: boolean;
    createOnb2c: boolean;
    price: string
    description: string
  }
  
  
const SignInSchemaValidation = Yup.object().shape({
    name: Yup.string().required('Nome é obrigatório'),
    code: Yup.string(),
    ncm: Yup.string(),
    personalized: Yup.boolean(),
    createOnNuvemShop: Yup.boolean(),
    createOnOmie: Yup.boolean(),
    price: Yup.string().required('Preço Unitário é obrigatório'),
    description: Yup.string(),
    createOnb2b: Yup.boolean(),
    createOnb2c: Yup.boolean(),
  });

  interface ICollaboratorsFormProps {
    createCollaboratorsUseCase: CreateCollaboratorsUseCase
    showCollaboratorsUseCase: ShowCollaboratorsUseCase
    updateCollaboratorsUseCase: UpdateCollaboratorsUseCase
  }
const CollaboratorsForm : FC<ICollaboratorsFormProps> = ({ createCollaboratorsUseCase, showCollaboratorsUseCase, updateCollaboratorsUseCase }) => {
   

    const { handleAction, loading, errors, register, control, handleSubmit, menuOptions, expandedMenus, toggleMenuExpansion, watch } = useCreateCollaborators({
      createCollaboratorsUseCase,
      showCollaboratorsUseCase,
      updateCollaboratorsUseCase
    })
 
    
    return (
      <Can permissions={['menu:collaborators:manage']}>
        <BaseScreen>
            
            <Paper >
                <BaseContentPage 
                    title='Colaboradores'
                    breadcrumb={[{ title: 'Colaboradores', link: "/collaborators-list"}, { title: 'Novo Colaborador'}]}
                >

                {loading && <Loader />}

                <Grid2 container spacing={5} sx={{ marginTop: 2}} component="form" onSubmit={handleSubmit(handleAction)}>


                <Grid2 size={6}>
                    <Input
                        label="Nome"
                        placeholder="Preencha o nome"
                        error={!!errors.name}
                        helperText={errors.name?.message}
                        {...register('name')}
                    />


                </Grid2>

                <Grid2 size={6}>
                  <Input
                      label="E-mail"
                      placeholder="Preencha o e-mail"
                      error={!!errors.username}
                      helperText={errors.username?.message}
                      {...register('username')}
                    />
                </Grid2>

                
                
                <Grid2 size={12}>
                

                <Typography marginY='0px' fontSize='19px' fontWeight='600'>Menus de acesso deste colaborador:</Typography>
                  

                  {menuOptions?.map(menu => (
                    <Box key={menu.value} sx={{ marginTop: '20px' }}>
                      {/* Menu Principal */}
                      <Grid2 size={12} sx={{ display: 'flex', alignItems: 'center' }}>
                      {menu.features.length > 0 ? (
                          <IconButton
                            onClick={() => toggleMenuExpansion(menu.value)}
                            size="small"
                            sx={{ mr: 1 }}
                          >
                            {expandedMenus[menu.value] ? <ExpandLess /> : <ExpandMore />}
                          </IconButton>
                        ) : <Box sx={{ width: '40px' }} />}

                        <Switch label={menu.label} name={`swtich-${menu.value}`} control={control} />
                        
                      </Grid2>

                      {/* Sub-funcionalidades */}
                      {menu.features.length > 0 && (
                        <Collapse in={expandedMenus[menu.value]} timeout="auto" unmountOnExit>
                          <Box sx={{ pl: 4, mt: 1, ml: '40px' }}>
                            {menu.features.map(feature => (
                              <Grid2 size={12} sx={{ marginTop: '10px' }} key={feature.value}>
                                <Switch label={feature.label} name={`swtich-${feature.value}`} control={control} />
                              </Grid2>
                            ))}
                          </Box>
                        </Collapse>
                      )}
                    </Box>
                  ))}
                  
                </Grid2>              

                <Button type="submit" sx={{ marginTop: '10px', width: '200px' }} isLoading={loading}>
                    SALVAR
                </Button>
                </Grid2>

              </BaseContentPage>
              
            </Paper>
                
        </BaseScreen>
      </Can>
    )
}

export { CollaboratorsForm };
